module.exports = __webpack_public_path__ + "img/ind_flag.d6fbef1f.svg";